var _path, _path2, _rect, _path3, _rect2, _rect3, _rect4, _rect5, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVbsTreeColored(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 88,
    viewBox: "0 0 144 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.25 3.59966C63.25 2.83323 63.8713 2.21191 64.6377 2.21191H87.6828C88.1 2.21191 88.4381 2.55007 88.4381 2.96721C88.4381 18.1577 100.752 30.472 115.943 30.472H139.27C140.036 30.472 140.657 31.0933 140.657 31.8597V42.5999C140.657 43.3663 140.036 43.9876 139.27 43.9876H64.6377C63.8713 43.9876 63.25 43.3663 63.25 42.5999V3.59966Z",
    fill: "currentColor",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2188 4.6693C36.2188 3.31212 37.319 2.21191 38.6761 2.21191H42.3622H53.4204C54.7776 2.21191 55.8778 3.31212 55.8778 4.6693V13.8845V83.306C55.8778 84.6631 54.7776 85.7633 53.4204 85.7633H38.6761C37.319 85.7633 36.2188 84.6631 36.2188 83.306V4.6693Z",
    fill: "currentColor",
    opacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.1797,
    y: 2.05566,
    width: 19.5615,
    height: 84,
    rx: 2.77549,
    stroke: "currentColor",
    strokeWidth: 2.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.25 53.9756C63.25 53.2092 63.8713 52.5879 64.6377 52.5879H66.2337C66.2823 52.5879 66.3217 52.6273 66.3217 52.6759C66.3217 56.1201 69.1137 58.9121 72.5579 58.9121H139.623C140.194 58.9121 140.657 59.3754 140.657 59.9469V69.6306C140.657 70.397 140.036 71.0184 139.27 71.0184H64.6377C63.8713 71.0184 63.25 70.397 63.25 69.6306V53.9756Z",
    fill: "currentColor",
    opacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62.6367,
    y: 2.05566,
    width: 79.1019,
    height: 42.9896,
    rx: 2.77549,
    stroke: "currentColor",
    strokeWidth: 2.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 63.25,
    y: 51.3594,
    width: 78.6361,
    height: 20.8879,
    rx: 2.77549,
    stroke: "currentColor",
    strokeWidth: 2.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 63.25,
    y: 77.1621,
    width: 78.6361,
    height: 8.60088,
    rx: 2.77549,
    stroke: "currentColor",
    strokeWidth: 2.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 63.25,
    y: 77.1621,
    width: 78.6361,
    height: 8.60088,
    rx: 2.77549,
    fill: "currentColor",
    opacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56813 51.5367C12.3811 51.5367 15.4722 48.4457 15.4722 44.6326C15.4722 40.8196 12.3811 37.7285 8.56813 37.7285C4.75513 37.7285 1.66406 40.8196 1.66406 44.6326C1.66406 48.4457 4.75513 51.5367 8.56813 51.5367Z",
    stroke: "currentColor",
    strokeWidth: 2.45739
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56813 51.5367C12.3811 51.5367 15.4722 48.4457 15.4722 44.6326C15.4722 40.8196 12.3811 37.7285 8.56813 37.7285C4.75513 37.7285 1.66406 40.8196 1.66406 44.6326C1.66406 48.4457 4.75513 51.5367 8.56813 51.5367Z",
    fill: "currentColor",
    opacity: 0.5,
    strokeWidth: 2.45739
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9562 2.05566H29.5685C28.0356 2.05566 26.793 3.2983 26.793 4.83116V83.2383C26.793 84.7712 28.0356 86.0138 29.5685 86.0138H30.9562",
    stroke: "currentColor",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.207 44.3828L26.758 44.3828",
    stroke: "currentColor",
    strokeWidth: 2.8,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7148 37.1035H88.9165",
    stroke: "currentColor",
    strokeWidth: 2.62499,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7148 32.1885H81.5444",
    stroke: "currentColor",
    strokeWidth: 2.62499,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7148 65.3633H88.9165",
    stroke: "currentColor",
    strokeWidth: 2.62499,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7148 60.4482H81.5444",
    stroke: "currentColor",
    strokeWidth: 2.62499,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7148 81.4629H81.5444",
    stroke: "currentColor",
    strokeWidth: 2.62499,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVbsTreeColored);
export default __webpack_public_path__ + "static/media/vbs-tree-colored.6a566b304e1219b576aed91bcca67a3a.svg";
export { ForwardRef as ReactComponent };